import React from 'react';
import Tooltip from '@mui/material/Tooltip';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

class TestCallStatusIcon extends React.PureComponent {

  formatLocalDateTime(utcString) {
    if (!utcString) return 'no test call yet';

    const d = new Date(utcString);
    if (isNaN(d.getTime())) return 'invalid date';

    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }

  getIconConfig() {
    const { datetime, result, reason } = this.props;

    // no test call yet
    if (!datetime) {
      return {
        Icon: HelpOutlineIcon,
        color: 'warning',
        tooltip: `no test call yet`,
      };
    }

    const d = new Date(datetime);
    const t = d.getTime();
    const localTime = this.formatLocalDateTime(datetime);

    // invalid date string
    if (isNaN(t)) {
      return {
        Icon: ErrorIcon,
        color: 'error',
        tooltip: `invalid testcall date:\n${String(datetime)}`,
      };
    }

    const ageMs = Date.now() - t;
    const isSuccess = (result === true || String(result).toLowerCase() === "true");

    if (ageMs > ONE_DAY_MS) {
      return {
        Icon: ErrorIcon,
        color: 'error',
        tooltip: `last test call:\n${localTime}\n${reason || 'expired (> 24h)'}`,
      };
    }

    if (isSuccess) {
      return {
        Icon: CheckCircleIcon,
        color: 'success',
        tooltip: `successful test call:\n${localTime}\n${reason || ''}`.trim(),
      };
    }

    return {
      Icon: ErrorIcon,
      color: 'error',
      tooltip: `failed test call:\n${localTime}\n${reason || ''}`.trim(),
    };
  }

  render() {
    const { Icon, color, tooltip } = this.getIconConfig();

    return (
      <Tooltip
        title={<span style={{ whiteSpace: 'pre-line' }}>{tooltip}</span>}
        arrow
      >
        <span>
          <Icon sx={{ fontSize: 32 }} color={color} />
        </span>
      </Tooltip>
    );
  }
}

export default TestCallStatusIcon;
